export default __webpack_public_path__ + "static/media/Kalderos_Wordmark_GreyDarker.11a05ed7.svg";